import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { Breadcrumb } from 'antd';
import { Link } from 'react-router-dom';
import Metabase from 'components/Metabase';

import text from './TransactionMeta.page.translation';

class TransactionMeta extends Component {
  render() {
    const {
      intl: { formatMessage },
    } = this.props;
    return (
      <div className="main-content">
        <div className="breadcrumb-wrapper">
          <Breadcrumb>
            <Breadcrumb.Item>
              <Link to="/">{formatMessage(text.home)}</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              {formatMessage(text.transactionsTitle)}
            </Breadcrumb.Item>
          </Breadcrumb>
        </div>

        <Metabase
          title="metabase miles"
          allowTransparency
          resourceKey="question"
          resource={{ question: 40 }}
        />
      </div>
    );
  }
}

TransactionMeta.propTypes = {
  intl: PropTypes.object.isRequired,
};

export default TransactionMeta;
